<template>
  <div>
    <b-button v-if="dataToShow" size="sm" variant="dark" v-b-modal="'modalTaskHooksLastResponse' + rnd" v-translate>View</b-button>
    <b-modal size="xl" :id="'modalTaskHooksLastResponse' + rnd" :ref="'modalTaskHooksLastResponse' + rnd" hide-header hide-footer>
      <pre><code>{{ dataToShow }}</code></pre>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ListItemTaskHooksLastResponse',
  props: {
    data: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {
      rnd: Math.random(),
      dataToShow: null
    }
  },
  mounted () {
    if (this.data) {
      try {
        this.dataToShow = JSON.parse(this.data)
      } catch (error) {
        this.dataToShow = `[${this.$gettext('gibberish')}]\n\n${this.data}\n\n[/${this.$gettext('gibberish')}]`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
pre {
  margin-bottom: 0 !important;
}
</style>
